import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app';
import { initializeDayjs } from './app/config/dayjs';
import { setupMsw } from './app/config/msw';
import './app/styles';
import '@/shared/lib/datadog';
import '@/shared/lib/umami';
import '@/shared/lib/i18n';
import { logger } from '@/shared/lib/logger';

/**
 * アプリケーションエントリポイント
 * App層の初期化とDOMレンダリング
 */

const bootstrap = async () => {
  try {
    // グローバル設定の初期化
    initializeDayjs();

    const mswEnabled = await setupMsw();

    if (mswEnabled) {
      logger.debug('[MSW] Mocking enabled');
    }

    // Render the app
    const rootElement = document.getElementById('root')!;
    if (!rootElement.innerHTML) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    }
  } catch (_error) {
    // フォールバック: MSWなしでアプリを起動
    const rootElement = document.getElementById('root')!;
    if (!rootElement.innerHTML) {
      const root = ReactDOM.createRoot(rootElement);
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    }
  }
};

void bootstrap();
